@if ((facade.discoverDetailsLoading$ | async) || (facade.discoverListDetailsLoading$ | async)) {
  <web-design-system-modal>
    @for (_ of [1, 2, 3, 4, 5]; track $index) {
      <div class="loading-shimmer position random"></div>
      <div class="loading-shimmer position"></div>
      <div class="loading-shimmer position mb-4"></div>
    }
  </web-design-system-modal>
} @else {
  <web-design-system-modal
    (dismiss)="handleClose.emit()"
    [headline]="(facade.discoverListDetails$ | async)?.longName ?? (facade.discoverDetails$ | async)?.headline"
  >
    @if (facade.discoverDetails$ | async; as article) {
      <div [innerHTML]="article.text | markdown"></div>
      @if (article.instruments && (article.instruments | recordToArray).length && facade.discoverDetailsQuotesReady$ | async) {
        <h5 class="mb-3 mt-3">{{ 'my-home.my-discover.discover-article.instruments-headline' | transloco }}</h5>
        @for (instrument of article.instruments | recordToArray | orderBy: 'performance' | reverse; track instrument.isin) {
          <ng-container
            *ngTemplateOutlet="articleInstrumentItem; context: { instrument: instrument, articleId: article.id, index: $index }"
          />
        }
      }
      @if (hasCta$ | async) {
        <div class="row">
          <div class="col d-flex justify-content-center">
            <web-design-system-button class="mt-2 mt-lg-0" (click)="handleCtaButtonClick(article.cta, article.id)">
              {{ article.cta.text | uppercase }}
            </web-design-system-button>
          </div>
        </div>
      } @else if (isins.length) {
        <div class="row">
          <div class="col d-flex justify-content-center">
            <web-design-system-button [disabled]="!isins.length" (click)="handleMultiorderButtonClick(article.id)">
              @if (article.cta?.text) {
                {{ article.cta.text | uppercase }}
              } @else if (isins.length === 1) {
                {{ 'my-home.my-discover.discover-article.multiorder-btn.single' | transloco | uppercase }}
              } @else {
                {{ isins.length }} {{ 'my-home.my-discover.discover-article.multiorder-btn.multi' | transloco | uppercase }}
              }
            </web-design-system-button>
          </div>
        </div>
      }
    }
    @if (facade.discoverListDetails$ | async; as article) {
      @if (article.text) {
        <div class="mb-3" [innerHTML]="article.text | markdown"></div>
      }
      @if (article.segments) {
        @if (initialSegment$ | async; as initialSegment) {
          <div class="nav-tabs">
            @for (segment of article.segments; track segment.name) {
              <div class="nav-item">
                <a
                  class="nav-link cursor-pointer"
                  (click)="activeSegment = segment.name"
                  [class.active]="!activeSegment ? initialSegment === segment.name : activeSegment === segment.name"
                >
                  {{ segment.name }}
                </a>
              </div>
            }
          </div>
          @if (article.instruments && (article.instruments | recordToArray).length && facade.discoverListDetailsQuotesReady$ | async) {
            @for (instrument of article.instruments | recordToArray; track instrument.isin) {
              @if (instrument.segment | isCurrentSegment: (!activeSegment ? initialSegment : activeSegment)) {
                <ng-container
                  *ngTemplateOutlet="articleInstrumentItem; context: { instrument: instrument, articleId: article.id, index: $index }"
                />
              }
            }
          }
        }
      } @else {
        @if (article.instruments && (article.instruments | recordToArray).length && facade.discoverListDetailsQuotesReady$ | async) {
          @for (instrument of article.instruments | recordToArray; track instrument.isin) {
            <ng-container
              *ngTemplateOutlet="articleInstrumentItem; context: { instrument: instrument, articleId: article.id, index: $index }"
            />
          }
        }
      }
    }
  </web-design-system-modal>
}

<ng-template #articleInstrumentItem let-instrument="instrument" let-articleId="articleId" let-index="index">
  <div class="instrument-row">
    <div class="name" [title]="instrument.name" (click)="handleClose.emit()">
      <web-components-instrument-details-link class="font-medium" [isin]="instrument.isin">
        {{ instrument.name }}
      </web-components-instrument-details-link>
    </div>
    <div class="d-flex justify-content-end align-items-center">
      <div>
        @if (instrument?.quote < 50) {
          {{ instrument?.quote | currency: 'EUR' : 'symbol' : '1.3' }}
        }
        @if (instrument?.quote >= 50) {
          {{ instrument?.quote | currency: 'EUR' : 'symbol' : '1.2' }}
        }
      </div>
      <div class="instrument-perf" [ngClass]="instrument.perfPct >= 0 ? { 'text-color-success': true } : { 'text-color-error': true }">
        {{ instrument.perfPct >= 0 ? '+' : '' }}{{ instrument.perfPct | number: '1.2-2' }}&nbsp;%
      </div>
      <div (click)="handleBuyButtonClick(instrument.isin, articleId, index)" class="trade buy small cursor-pointer ml-3">K</div>
    </div>
  </div>
  <hr class="less-margin" />
</ng-template>
